var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundtripIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.71118 21 0 16.2888 0 10.5C0 4.71119 4.71118 0 10.5 0C16.2888 0 21 4.71119 21 10.5C21 16.2888 16.2888 21 10.5 21ZM10.5 1.10526C5.31908 1.10526 1.10526 5.31908 1.10526 10.5C1.10526 15.6809 5.31908 19.8947 10.5 19.8947C15.6809 19.8947 19.8947 15.6809 19.8947 10.5C19.8947 5.31908 15.6809 1.10526 10.5 1.10526Z",
    fill: "#747474"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60425 8.60465C7.24225 7.14761 8.81479 6.31299 10.5102 6.31299C12.6547 6.31299 14.4175 7.94099 14.6251 10.0255",
    stroke: "#747474",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44254 8.78796H6.62296C6.55732 8.78796 6.49436 8.76189 6.44795 8.71547C6.40153 8.66906 6.37546 8.60611 6.37546 8.54046V6.72546M14.3958 12.2713C13.7578 13.7283 12.1853 14.563 10.4899 14.563C8.34537 14.563 6.58262 12.935 6.375 10.8505",
    stroke: "#747474",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5574 12.088H14.377C14.4095 12.088 14.4417 12.0943 14.4718 12.1067C14.5019 12.1191 14.5292 12.1374 14.5523 12.1603C14.5753 12.1833 14.5936 12.2106 14.606 12.2407C14.6185 12.2708 14.6249 12.303 14.6249 12.3355V14.1505",
    stroke: "#747474",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(5 4.93799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundtripIcon);
export default __webpack_public_path__ + "static/media/roundtripIcon.01ed7a0670b2b824f29a4ed57cfaaaec.svg";
export { ForwardRef as ReactComponent };